import { Users } from "lucide-react";
import { UserAvatar } from "@/components/UserAvatar";

function timeLabel(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date();
  if (d.toDateString() === today.toDateString())
    return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
}

export function ConversationList({ conversations, active, onSelect, dark = false, meId }) {
  return (
    <div className="flex-1 min-h-0 overflow-y-auto" data-testid="conversation-list">
      {conversations.map((c) => {
        const isTeam = c.type === "team";
        const isActive = active === c.conv;
        const counterpart = c.user || {};
        const senderName = c.last_message?.user_name?.split?.(" ")?.[0] || "Team";
        const preview = c.last_message
          ? `${c.last_message.user_id === meId ? "Du: " : isTeam ? `${senderName}: ` : ""}${c.last_message.text || "Anhang"}`
          : isTeam ? "Gruppenchat für das gesamte Team" : "Noch keine Nachrichten";
        return (
          <button
            key={c.conv || counterpart.id}
            data-testid={`conv-${isTeam ? "team" : counterpart.id || "unbekannt"}`}
            onClick={() => onSelect(c)}
            className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors border-b ${
              dark
                ? `border-neutral-800/60 ${isActive ? "bg-neutral-800" : "hover:bg-neutral-800/50"}`
                : `border-neutral-100 ${isActive ? "bg-neutral-100" : "hover:bg-neutral-50"}`
            }`}
          >
            {isTeam ? (
              <span className="h-11 w-11 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0">
                <Users className="h-5 w-5" />
              </span>
            ) : (
              <UserAvatar src={counterpart.avatar_url} name={c.name || "Kontakt"} color={counterpart.avatar_color} className="h-11 w-11" textClass="text-sm" />
            )}
            <span className="flex-1 min-w-0">
              <span className="flex items-baseline justify-between gap-2">
                <span className={`text-sm font-semibold truncate ${dark ? "text-white" : "text-neutral-900"}`}>
                    {isTeam ? "Team-Kanal" : c.name || "Kontakt"}
                </span>
                <span className={`text-[10px] shrink-0 ${c.unread > 0 ? "text-blue-500 font-bold" : dark ? "text-neutral-500" : "text-neutral-400"}`}>
                  {timeLabel(c.last_message?.created_at)}
                </span>
              </span>
              <span className="flex items-center justify-between gap-2 mt-0.5">
                <span className={`text-xs truncate ${dark ? "text-neutral-400" : "text-neutral-500"}`}>{preview}</span>
                {c.unread > 0 && (
                  <span
                    data-testid={`conv-unread-${isTeam ? "team" : counterpart.id || "unbekannt"}`}
                    className="shrink-0 h-5 min-w-5 px-1.5 rounded-full bg-blue-600 text-white text-[10px] font-bold flex items-center justify-center"
                  >
                    {c.unread > 99 ? "99+" : c.unread}
                  </span>
                )}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
